import { alpha } from "@mui/material/styles";

export const subscriptionCardSx = {
  border: 1,
  borderColor: "divider",
  borderRadius: 3,
  overflow: "hidden",
  boxShadow: "0 3px 16px rgba(30, 20, 50, 0.025)",
};

export const headCellSx = {
  fontWeight: 600,
  color: "text.secondary",
  borderBottom: "2px solid",
  borderColor: (theme) => alpha(theme.palette.divider, 0.1),
  py: 1.5,
  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.03),
};

export const bodyCellSx = {
  py: 1.5,
  borderColor: (theme) => alpha(theme.palette.divider, 0.08),
};
